'use client';

import * as DS from '@aurorasolar/ds';
import { x } from '@xstyled/styled-components';
import Image, { type StaticImageData } from 'next/image';

import { Eyebrow } from '../Eyebrow';

import logoBhg from './logo-bhg.svg';
import logoBloomberg from './logo-bloomberg.svg';
import logoForbes from './logo-forbes.svg';
import logoFortune from './logo-fortune.svg';
import logoNyt from './logo-nyt.svg';
import logoRealtor from './logo-realtor.webp';

const PRESS_LOGOS: { alt: string; height: number; src: StaticImageData; width: number }[] = [
  { alt: 'Forbes', height: 24, src: logoForbes, width: 89 },
  { alt: 'The New York Times', height: 24, src: logoNyt, width: 178 },
  { alt: 'Fortune', height: 24, src: logoFortune, width: 104 },
  { alt: 'Bloomberg', height: 24, src: logoBloomberg, width: 119 },
  { alt: 'Realtor.com', height: 24, src: logoRealtor, width: 120 },
  { alt: 'Better Homes & Gardens', height: 20, src: logoBhg, width: 278 },
];

export const AsSeenIn = () => (
  <DS.Flex gap={8}>
    <DS.Flex alignItems="center" flexDirection="row" gap={4} maxW="900px" mx="auto">
      <x.div bg="uiDivider" flex={1} h="1px" />
      <Eyebrow color="uiHelperCopy">As seen in</Eyebrow>
      <x.div bg="uiDivider" flex={1} h="1px" />
    </DS.Flex>
    <DS.Flex
      alignItems="center"
      flexDirection="row"
      flexWrap="wrap"
      gap={{ _: 6, md: 8 }}
      justifyContent="center"
      opacity={0.6}
    >
      {PRESS_LOGOS.map(({ alt, height, src, width }) => (
        <x.div flexShrink={0} key={alt} w={{ _: Math.round(width * 0.75), md: width }}>
          <Image alt={alt} height={height} src={src} style={{ height: 'auto', width: '100%' }} width={width} />
        </x.div>
      ))}
    </DS.Flex>
  </DS.Flex>
);
